import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';

import Loading from '../../components/Loading';
import Error from '../../components/Error';
import MainHeader from './MainHeader';
import IndicatorGroup from './IndicatorGroup';

const map_ids = (c,g) => {c[g.id] = g.data(); return c;}

export default class Dashboard extends Component {

    constructor(props) {
        super(props);
        
        this.dashboardRef = firebase.firestore().collection('dashboard').doc('page');
        this.goalsRef = firebase.firestore().collection('goals');
        this.targetsRef = firebase.firestore().collection('targets');
        this.indicatorsRef = firebase.firestore().collection('indicators');
        this.groupsRef = firebase.firestore().collection('indicatorGroups');

        this.state = {
            loading: true,
        };
    }

    async componentDidMount() {
        try {
            let [dashboardDoc, goalsSnap, targetsSnap, indicatorsSnap, groupsSnap] = await Promise.all([
                this.dashboardRef.get(),
                this.goalsRef.get(),
                this.targetsRef.get(),
                this.indicatorsRef.get(),
                this.groupsRef.get(),
            ]);
            let groupDocs = groupsSnap.docs.sort( (d1, d2) => parseInt(d1.data().number) - parseInt(d2.data().number));
            this.setState({
                dashboard: dashboardDoc.exists ? dashboardDoc.data() : {},
                goals: goalsSnap.docs.reduce( map_ids, {}),
                targets: targetsSnap.docs.reduce( map_ids, {}),
                indicators: indicatorsSnap.docs.reduce( map_ids, {}),
                groups: groupDocs.map( g => g.data() ),
                loading: false
            });
        }
        catch( error ) {
            this.setState({error, loading: false});
        }
    }

    render() {
        let { onOpenURL } = this.props;
        let {dashboard, goals, targets, indicators, groups, error, loading} = this.state;
        return (
            <div className="Dashboard">
                { loading && 
                    <Loading />
                }
                { error && 
                    <Error 
                        title="Server Error" 
                        message={error} 
                    /> 
                }
                {dashboard &&
                    <div className="MainContainer">
                        <MainHeader 
                            title={dashboard.title} 
                            description={dashboard.description} 
                            backgroundImageURL={dashboard.backgroundImageURL}
                            moreInfoURL={dashboard.moreInfoURL}
                            onClickMoreInfo={onOpenURL}
                        />
                        <div className="IndicatorGroupsContainer">
                            {(groups || []).map( (group, index) => {
                                let goal = goals[group.goalRef.id];
                                let groupIndicators = group.indicators.map( r => {
                                    let indicator = indicators[r.indicatorRef.id];
                                    indicator.target = targets[indicator.targetRef.id];
                                    return indicator;
                                });
                                return (
                                    <IndicatorGroup 
                                        key={`IndicatorGroup-${index}`}
                                        imageURL={goal.imageURL}
                                        title={goal.title}
                                        detailColor={group.detailColor}
                                        indicators={groupIndicators}
                                        onOpenURL={onOpenURL}
                                    />
                                );
                            })}
                        </div>
                    </div>
                }
            </div>
        );
    }
}